import { createContext, useContext } from "react";
import type { GuestCheckoutPort } from "./port";

/**
 * A TEST SEAM for the guest checkout's three calls.
 *
 * Production supplies nothing here: GuestFlowHost then builds the Apollo
 * adapter over the generated booking-v1 operations (adapter.ts). Unit tests
 * and the local harness provide a fake port instead.
 *
 * It no longer decides WHETHER the verified checkout runs. Every anonymous
 * booking takes it; the build-time switch and the legacy anonymous commit it
 * guarded were removed with the guest-verification OFF build (f13,
 * 2026-10-07).
 */
export const GuestCheckoutPortContext = createContext<GuestCheckoutPort | null>(null);

export function useGuestCheckoutPort(): GuestCheckoutPort | null {
  return useContext(GuestCheckoutPortContext);
}
